import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import { Viewer } from "../../../../../widgets/Viewer";
import { withRouter } from 'react-router-dom';
import { Spinner } from '@blueprintjs/core';

import { loadPhotos, deletePhoto } from '../../../../../../redux/actions/photo.actions';

const PhotoRow = props => {
    return (
        <tr onClick={() => props.editRow(props.photo)}>
            <td>{moment(props.photo.date_taken).format('ddd, MMM Do, YYYY')}</td>
            <td onClick={e => e.stopPropagation()}>
                <Viewer src={props.photo.image || props.photo.dropbox_image_share_url || ''} style={{ height: '30px' }} thumbnail />
            </td>
            <td className="action-row">
                <div className="pt-button pt-intent-danger pt-icon-trash pt-small" onClick={(event) => props.deleteRow({ photo: props.photo, event })}>Delete</div>
            </td>
        </tr>
    );
};

class Photos extends Component {
    async componentDidMount() {
        const { clientId, progressId } = this.props.match.params;
        await this.props.loadPhotos({ recipientId: clientId, progressId });
    }
    openPhotosModal = () => {
        const event = new CustomEvent('open-photo-modal', {
            detail: {
                ...this.props.match.params,
                recipientId: this.props.match.params.clientId
            }
        });
        window.dispatchEvent(event);
    }
    editRow = (photo) => {
        const { clientId, progressId } = this.props.match.params;
        const event = new CustomEvent('open-photo-modal', {
            detail: {
                ...photo,
                recipientId: clientId,
                progressId
            }
        });
        window.dispatchEvent(event);
    }
    deleteRow = ({ event, photo }) => {
        event.preventDefault();
        event.stopPropagation();
        const { clientId, progressId } = this.props.match.params;
        const customEvent = new CustomEvent('open-delete-modal', {
            detail: {
                content: `Are you sure you want to delete this photo?`,
                onDelete: () => {
                    this.props.deletePhoto({ recipientId: clientId, progressId, photoId: photo.id });
                }
            }
        });
        window.dispatchEvent(customEvent);
    }
    render() {
        const { photos } = this.props;
        return (
            <div className="panel-photos panel-content">
                { this.props.allLoading ?
                    <div className="spinner-container">
                        <Spinner large />
                    </div> :
                    photos.length ?
                        <table className="general-table pt-html-table pt-interactive">
                            <thead>
                                <tr>
                                    <th>Date Taken</th>
                                    <th>Preview</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                { photos.map((photo, i) => (
                                    <PhotoRow key={i}
                                        photo={photo}
                                        editRow={this.editRow}
                                        deleteRow={this.deleteRow} />
                                ))}
                            </tbody>
                        </table> :
                        <div className="intro">
                            <div className="intro-text">
                                No photos. Start by <span className="link" onClick={this.openPhotosModal} >adding one</span>
                            </div>
                        </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    photos: state.photo.photos,
    photosById: state.photo.photosById,
    allLoading: state.photo.allLoading
});

const mapDispatchToProps = {
    loadPhotos,
    deletePhoto
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Photos));


// WEBPACK FOOTER //
// ./src/components/main/dashboard/panel/recipient/progress-panels/Photos.jsx